<template>
    <b-row class="g-0">
        <b-col cols="12" class="dd">
            <b-input-group>
                <b-form-select
                    class="form-control"
                    v-bind="$attrs"
                    v-on="$listeners"
                    :required="required"
                    v-custom-validation="required ? $selectRequired() : ''"
                    :options="contact_options"
                    :value="value"
                >
                    <template #first>
                        <b-form-select-option :value="null" disabled>
                            <slot></slot>
                        </b-form-select-option>
                    </template>
                </b-form-select>

                <div class="d-flex gap-2 ms-2">
                    <b-button
                        :disabled="!value"
                        @click="showContact"
                        v-b-tooltip.hover
                        :title="$translate('display_contact_details')"
                        variant="blue-icon"
                    >
                        <!-- <b-icon icon="display" aria-label="Help"></b-icon> -->
                        <img src="@/assets/images/icon/display.svg" />
                    </b-button>
                    <b-button
                        :disabled="!customer_id || $attrs.disabled"
                        @click="openNewContact"
                        v-b-tooltip.hover
                        :title="$translate('create_new_contact')"
                        variant="blue-icon"
                    >
                        <!-- <b-icon icon="plus-circle" aria-label="Help"></b-icon> -->
                        <img src="@/assets/images/icon/gradient-add.svg" />
                    </b-button>
                </div>
            </b-input-group>
        </b-col>

        <b-col cols="12">
            <customer-users
                v-show="false"
                ref="customerContactRef"
            ></customer-users>
        </b-col>
    </b-row>
</template>
<script>
import CustomerUsers from '@/components/CustomerUsers.vue'
export default {
    name: 'ContactSelection',
    components: { CustomerUsers },
    props: {
        value: {
            type: Number,
            default: 0,
        },
        required: {
            type: Boolean,
            default: false,
        },
        customer_id: {
            type: Number,
            default: 0,
        },
    },

    computed: {
        customer_contacts() {
            return this.$store.getters['customers/customerUsers']
        },
        contact_options() {
            const contacts = this.customer_contacts
            console.log('contact selection --contacts', contacts)
            return contacts.map(x => ({
                value: x.id,
                text: x.first_name + ' ' + x.last_name,
            }))
        },
    },

    mounted() {
        console.log('$attrs', this.$attrs)
    },

    methods: {
        showContact() {
            const { value: customer_contact_id, customer_contacts } = this
            const contact = customer_contacts.find(
                x => x.id == customer_contact_id
            )
            console.log({ customer_contact_id, customer_contacts, contact })
            this.$refs.customerContactRef.viewCustomer(contact)
        },

        openNewContact() {
            this.$refs.customerContactRef.viewCustomer()
        },
    },
}
</script>
